import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { RcHeadingProps } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcHeading',
  props: {
    size: {}
  },
  setup(__props: any) {

/**
 * A section title, with a look set by `size` rather than by a heading tag. It renders a `div`, so
 * it carries no outline level and adds nothing to the page's heading structure.
 *
 * Example:
 *
 * <RcHeading :size="4">Language</RcHeading>
 */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`size-${ __props.size }`)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})